import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cue-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LoadingComponent {
  positionX = input<'left' | 'center' | 'right'>('center');
  positionY = input<'top' | 'center' | 'bottom'>('center');

  get positionClasses(): string {
    return 'position-x-' + this.positionX() + ' position-y-' + this.positionY();
  }
}
